<template>
  <div
    class="calendar-month-day"
    :class="{
      'calendar-month-day-weekend': item.nWeek > 5,
      'calendar-month-day-other': item.cMonth !== selectedMonth
    }"
    v-clickoutside="closeModal"
    @dblclick="createTask(item)"
  >
    <div
      class="calendar-month-day-header"
      :class="{
        'active': item.isToday && selectedMonth === item.cMonth,
      }"
    >
      <div class="calendar-month-day-sorlar" v-if="item.isTerm && !item.isHoliday">{{ item.term }}</div>
      <div class="calendar-month-day-sorlar" v-else-if="item.isHoliday">{{ item.holiday.length && item.holiday[0] }}</div>
      <div class="calendar-month-day-sorlar" v-else>{{ item.dayCn === '初一' ? item.monthCn : item.dayCn }}</div>
      <task-tags v-show="!item.restType" :tags="item.tags" />
      <div v-if="item.tags" v-show="item.restType" class="dot"></div>
      <work-icon v-show="item.restType" :item="item" />
      <div
        class="calendar-month-day-num"
      >{{ item.cDay }}</div>
    </div>
    <div
      v-if="item.tasks&&item.tasks.length > 1"
      class="calendar-month-day-footer"
    >
      <div
        @click="showAll"
        class="calendar-month-day-label"
      >
        <span class="label">{{ `更多${item.tasks&&item.tasks.length-1}个` }}</span>
        <span class="ibass ibass-trig-down" />
      </div>
    </div>
    <div class="calendar-month-day-list">
      <task-list
        v-if="triggered"
        :tasks="item.tasks"
        :date="item"
        @close="triggered=false"
      />
    </div>
    <div
      :ref="`date${item.millisecond}`"
      :draggable="true"
      @dragstart="dragStart(item, $event)"
      @dragend="dragEnd(item, $event)"
      class="calendar-task-create-drag"
    ></div>
  </div>
</template>
<script>
import clickoutside from '@/directives/clickoutside'
import TaskList from '../tasks/taskList'
import workIcon from './workIcon.vue'
import { TASK_DETAIL } from '@/utils/constants'
import TaskTags from '@/biz-components/task-tags/index.vue'
export default {
  name: 'CalendarMonthDay',
  directives: {
    clickoutside
  },
  components: {
    TaskTags,
    TaskList,
    workIcon
  },
  props: {
    item: Object,
    curDate: {
      type: String,
      default: moment().format('YYYY-MM')
    }
  },
  data () {
    return {
      triggered: false,
      selectedMonth: 0,
      creating: false
    }
  },
  watch: {
    curDate () {
      this.setActiveMonth()
      this.calcTags()
    },
    item () {
      this.calcTags()
    }
  },
  created () {
    this.setActiveMonth()
    this.calcTags()
  },
  methods: {
    showAll () {
      if (this.item.tasks.length > 200) {
        this.$postMessage.stateGo('app.my.task')
      } else {
        this.triggered = true
      }
    },
    // 开始
    dragStart (item, event) {
      if (this.creating) {
        return false
      }
      this.creating = true
      event.dataTransfer.setDragImage(this.$refs[`date${item.millisecond}`], 10, 10)
      let newTask = {
        'createOrder': 1,
        'startTime': item.millisecond,
        'endTime': item.millisecond,
        'initTime': item.millisecond,
        'moveTime': item.millisecond,
        'name': '新建任务'
      }
      this.$store.commit('setDraggingCreateTask', newTask)
    },
    dragEnd () {
      this.dragCreateTask(JSON.parse(JSON.stringify(this.$store.state.calendar.draggingCreateTask)))
      this.$store.state.calendar.draggingCreateTask = null
      this.creating = false
    },
    createTask (item) {
      this.$store.commit('createTask', { dueTime: item.millisecond, dayType: 1 })
    },
    dragCreateTask (item) {
      this.$store.commit('createTask', { ...item, dayType: TASK_DETAIL.DAY_TYPE_ALL })
    },
    setActiveMonth () {
      this.selectedMonth = moment(this.curDate, 'YYYY-MM').get('month') + 1
    },
    calcTags() {
      this.item.tags = Array.isArray(this.item.tasks) ? this.item.tasks.reduce((tags, task) => {
        return tags | task.tags
      }, 0) : 0
    },
    closeModal () {
      this.triggered = false
    }
  }
}
</script>
<style lang="stylus">
.calendar-month-day
  position relative
  font-size 10px
  color #000
  .calendar-task-create-drag
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    z-index 0
  &-list
    background-color #fff
    position absolute
    left -2px
    top -3px
    border 1px solid #ededed
    border-radius 2px
    box-shadow 0 4px 9px 0 rgba(0, 0, 0, .1)
    z-index 3
  &-weekend
    background-color #fbfbfb
    color #a6a6a6
  &-header
    display flex
    justify-content space-between
    align-items center
    padding 0 8px 0 5px
    &.active
      color #ed6c00
    .dot
      position: absolute;
      right: 5px;
      top: 1px;
      width: 4px;
      height: 4px;
      border-radius: 50%
      background-color #3378FF
  &-other
    color #ccc
    .task-tags
      opacity: .6
  &-footer
    position relative
    margin-top 28px
    margin-left 5px
    z-index 1
  &-label
    display flex
    color #666
    cursor pointer
    .label
      width 68px
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
    .ibass-trig-down
      color #cdc9c5
      vertical-align -1px
</style>
